export default {"src":"/uk/_next/static/media/tooltip.e8a8cc6b.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};